"use client";

import * as Select from "@radix-ui/react-select";
import classNames from "classnames";
import { FC, useState } from "react";

import typoStyles from "@/shared/ui/typography/typography.module.scss";
import ChevronIcon from "@/svgs/angle_right_b.svg";

import styles from "./dropdown.module.scss";
import { DropdownProps } from "./dropdown.types";

// TODO: fix popper when props fullWidth=true, p.s: --radix-select-trigger-width in scss

const Dropdown: FC<DropdownProps> = ({
  fullWidth = false,
  value,
  options,
  placeholder,
  defaultValue,
  maxViewItems,
  onValueChanged,
}) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);

  return (
    <Select.Root defaultValue={defaultValue} value={value} onOpenChange={setIsOpened} onValueChange={onValueChanged}>
      <Select.Trigger className={classNames(styles.trigger, fullWidth && styles.fullWidth)}>
        <Select.Value placeholder={placeholder}>{value}</Select.Value>

        <Select.Icon className={classNames(styles.icon, isOpened && styles.reversed)}>
          <ChevronIcon />
        </Select.Icon>
      </Select.Trigger>

      <Select.Portal>
        <Select.Content
          position="popper"
          sideOffset={4}
          style={{
            maxHeight: maxViewItems ? 36 * maxViewItems + 8 : undefined,
          }}
          className={classNames(styles.content)}
        >
          <Select.Viewport>
            {options.map(({ value, label }) => (
              <Select.Item key={value} className={classNames(typoStyles.footnote, styles.item)} value={value}>
                <Select.ItemText>{label}</Select.ItemText>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

Dropdown.displayName = "Dropdown";

export { Dropdown };
